export const layoutsMisc = {
  confirm: {
    defaultTitle: "Sind Sie sicher?",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
  },
  navPluginWeb: {
    title: "Website erstellen",
    stepOf: "{step} von 5",
  },
  saMenu: {
    title: "Systemaktionen",
    subtitle: "Automatisierungen",
    sectionComms: "KOMMUNIKATION",
    firstCheckin: "Beim ersten Check-in senden",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Wenden Sie sich an den Support, um die Verbindung einzurichten.",
    contactSupport: "Support kontaktieren",
  },
  selectionScanner: {
    title: "Wählen Sie die Art des Dokuments zum Scannen",
    idCard: "Personalausweis",
    passport: "Reisepass",
  },
};
